"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("../../Services/service.service");
var EmptyPageComponent = /** @class */ (function () {
    function EmptyPageComponent(service) {
        this.service = service;
    }
    EmptyPageComponent.prototype.ngOnInit = function () {
    };
    return EmptyPageComponent;
}());
exports.EmptyPageComponent = EmptyPageComponent;
